import cls from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useWindowSize } from 'usehooks-ts';

import Carousel from '../../core/ImageCarousel';
import Step from '../base/Step';

import useStyles from './styles';
import IInteractiveStepSection from './types';

function InteractiveStepSection({
  title,
  steps,
  className,
  TitleTag = 'h2',
}: IInteractiveStepSection) {
  const classes = useStyles();
  const { width } = useWindowSize();

  const [activeStep, setActiveStep] = useState<number>(0);
  const [isWeb, setIsWeb] = useState(true);

  useEffect(() => {
    if (width && width < 1096) setIsWeb(false);
    else setIsWeb(true);
  }, [width]);

  const onStepClick = useCallback(
    (index: number) => () => {
      setActiveStep(index);
    },
    [],
  );

  return (
    <section className={cls(classes.root, className)}>
      {isWeb ? (
        <div className={cls('flex', classes.desktop)}>
          <div className={cls('flex', classes.stepsContainer)}>
            <TitleTag className={cls('fs-42', classes.title)}>{title}</TitleTag>
            <div className={cls('flex', classes.steps)}>
              {steps.map((step, index) => (
                <Step
                  key={index}
                  index={index + 1}
                  title={step.title}
                  description={step.description}
                  isSelected={activeStep === index}
                  onClick={onStepClick(index)}
                  hasArrow
                />
              ))}
            </div>
          </div>
          <div className={classes.imageContainer}>
            <LazyLoadImage src={steps[activeStep].src} alt={steps[activeStep].imgAlt} />
          </div>
        </div>
      ) : (
        <div className={classes.mobile}>
          <TitleTag className={cls('fs-42', classes.title)}>{title}</TitleTag>
          <Carousel
            items={steps.map((step, index) => ({
              src: step.src,
              mobileSrc: step.mobileSrc,
              alt: step.imgAlt,
              content: (
                <Step
                  className={classes.step}
                  key={index}
                  index={index + 1}
                  title={step.title}
                  description={step.description}
                  isSelected={true}
                  hasArrow={false}
                  onClick={onStepClick(index)}
                />
              ),
            }))}
            onChange={onStepClick}
          />
        </div>
      )}
    </section>
  );
}

export default InteractiveStepSection;
